import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

export interface ColumnsProps {
  columns: string[];
}

export const Columns = (props: ColumnsProps) => {
  return getTableColumnsOrFields(props, Messages.column_table_columns());
};

export const Fields = (props: ColumnsProps) => {
  return getTableColumnsOrFields(props, Messages.tableTooltipFields());
};

function getTableColumnsOrFields(props: ColumnsProps, headerMsg: string) {
  return props.columns && props.columns.length > 0 ? (
    <>
      <dt className={DetailsTooltipStyles.DescriptionTerm}>{headerMsg}</dt>
      <dd className={DetailsTooltipStyles.DescriptionDetails}>
        { props.columns.join(', ') }
      </dd>
    </>
  ) : null;
}